<template>
  <div>
    <div v-show="page1">
      <img class="bg" src="../assets/02/background/background.png" />
      <img
        style="position:absolute;left:30vw;top:60vw;width:40vw;"
        src="../assets/02/content_card/content-01.png"
      />
      <div
        class="vtgrid"
        style="left:10vw;top:82vw;"
        :style="`grid-template-columns: repeat(3, 1fr);`"
      >
        <img
          style="width:27vw;"
          :src="
            selected[0]
              ? require('../assets/02/content_card/card_a2.png')
              : require('../assets/02/content_card/card_a1.png')
          "
          @click="SelectAnswer(0)"
        />
        <img
          style="width:27vw;"
          :src="
            selected[1]
              ? require('../assets/02/content_card/card_b2.png')
              : require('../assets/02/content_card/card_b1.png')
          "
          @click="SelectAnswer(1)"
        />
        <img
          style="width:27vw;"
          :src="
            selected[2]
              ? require('../assets/02/content_card/card_c2.png')
              : require('../assets/02/content_card/card_c1.png')
          "
          @click="SelectAnswer(2)"
        />
      </div>
      <img
        v-show="isselected"
        style="position:absolute;left:30vw;top:128vw;width:40vw;"
        src="../assets/02/content_card/content-01-增.png"        
      />      
      <img
        v-show="isselected"
        style="position:absolute;left:42vw;top:137vw;width:16vw;"
        src="../assets/02/icon/icon-01.png"
        @click="OnSend"
      />
    </div>
    <div v-show="page2">
      <img class="bg" src="../assets/02/background/background.png" />
      <img
        style="position:absolute;left:20vw;top:63vw;width:60vw;"
        src="../assets/02/content_card/content-02.png"
      />
      <div
        class="vtgrid"
        style="left:10vw;top:78vw;"
        :style="`grid-template-columns: repeat(3, 1fr);`"
      >
        <img
          style="width:27vw;"
          :src="
            result[0]
              ? require('../assets/02/content_card/card-d1.png')
              : require('../assets/02/content_card/card.png')
          "
          @click="SelectResult(0)"
        />
        <img
          style="width:27vw;"
          :src="
            result[1]
              ? require('../assets/02/content_card/card-e1.png')
              : require('../assets/02/content_card/card.png')
          "
          @click="SelectResult(1)"
        />
        <img
          style="width:27vw;"
          :src="
            result[2]
              ? require('../assets/02/content_card/card-f1.png')
              : require('../assets/02/content_card/card.png')
          "
          @click="SelectResult(2)"
        />
      </div>
      <transition name="slide-fade">
        <img
          v-show="isselected"
          style="position:absolute;left:10vw;top:123vw;width:80vw;"
          :src="
            require(`../assets/02/content_card/card-${resultid}2.png`)
          "
        />
      </transition>
      <transition name="slide-fade">
        <img
          v-show="isselected"
          style="position:absolute;left:17vw;top:154vw;width:66vw;"
          :src="
            require(`../assets/02/content_card/card-${resultid}3.png`)
          "
        />
      </transition>

      <div v-show="isselected" style="position:absolute;top:165vw;left:40vw;">        
        <img
          style="width:20vw;"
          src="../assets/01/icon/icon-02.png"
          @click="OnShowPage1"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page1: true,
      page2: false,
      isselected: false,
      selected: [false, false, false],
      result: [false, false, false],
      resultid: "d",
    };
  },
  mounted() {},
  methods: {
    SelectAnswer(index) {
      this.isselected = true;
      for (var i = 0; i < this.selected.length; i++) {
        if (i != index) {
          this.selected[i] = false;
        } else {
          this.selected[i] = true;
        }
      }
      this.$forceUpdate();
    },
    SelectResult(index) {
      if (!this.isselected) {
        if (index == 0) {
          this.resultid = "d";
        } else if (index == 1) {
          this.resultid = "e";
        } else if (index == 2) {
          this.resultid = "f";
        }
        this.isselected = true;
        for (var i = 0; i < this.result.length; i++) {
          if (i != index) {
            this.result[i] = false;
          } else {
            this.result[i] = true;
          }
        }
        this.$forceUpdate();
      }
    },
    OnShowPage1() {
      window.scrollTo(0,0);
      this.isselected = false;
      this.selected = [false, false, false];
      this.result = [false, false, false];
      this.page1 = true;
      this.page2 = false;
    },
    OnSend() {
      this.page1 = false;
      this.isselected = false;
      window.scrollTo(0,0);
      this.page2 = true;
    },
  },
};
</script>
<style scoped>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100vw;
  max-width: 100vw;
}
.vtgrid {
  position: absolute;
  height: auto;
  width: auto;
  display: grid;
  justify-items: center;
}
.slide-fade-enter-active {
  transition: all 0.8s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(30px);
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
